<template>
  <div>
    <SPreloader />
    <SSubHeader pageName="Message center" :backButton="true" />
    <div class="header-spacer--standard"></div>
    <md-content class="container page-content">
      <md-content v-if="conversationSortedByDate.length > 0" class="ui-block messages-content md-elevation-1">
        <div class="ui-block-title">
          <div>
            <SButtonMaterial
              color="transparent"
              buttonType="button"
              :textColor="selectedTab === 'all' ? 'tertiary' : 'darker-grey'"
              :iconColor="selectedTab === 'all' ? 'tertiary' : 'darker-grey'"
              iconTopText="clear_all"
              @button="setTab('all')"
              text="All"
              ref="allTab"
            />
          </div>
          <div>
            <SButtonMaterial
              color="transparent"
              buttonType="button"
              :textColor="
                selectedTab === 'items' ? 'tertiary' : 'darker-grey'
              "
              :iconColor="
                selectedTab === 'items' ? 'tertiary' : 'darker-grey'
              "
              iconTopText="storefront"
              @button="setTab('items')"
              text="Items"
              class="tab-button"
              ref="itemsTab"
            />
            <p
              class="icon-status unread"
              v-if="displayNewItemMessageNotice"
            ></p>
          </div>
          <div>
            <SButtonMaterial
              color="transparent"
              buttonType="button"
              :textColor="
                selectedTab === 'groups' ? 'tertiary' : 'darker-grey'
              "
              :iconColor="
                selectedTab === 'groups' ? 'tertiary' : 'darker-grey'
              "
              iconTopText="groups"
              @button="setTab('groups')"
              text="Groups"
              class="tab-button"
              ref="groupsTab"
            />
            <span
              class="icon-status unread"
              v-if="displayNewGroupMessageNotice"
            ></span>
          </div>
          <div>
            <SButtonMaterial
              color="transparent"
              buttonType="button"
              :textColor="
                selectedTab === 'users' ? 'tertiary' : 'darker-grey'
              "
              :iconColor="
                selectedTab === 'users' ? 'tertiary' : 'darker-grey'
              "
              iconTopText="account_circle"
              @button="setTab('users')"
              text="Users"
              class="tab-button"
              ref="usersTab"
            />
            <span
              class="icon-status unread"
              v-if="
                displayNewItemMessageNotice || displayNewGroupMessageNotice
              "
            ></span>
          </div>
        </div>

        <div class="row chat-box">
          <div class=" mr-0 remove-padding chat-list">
            <div class="sub-tab" v-if="selectedTab === 'users' && userSelectedByTab">
              <div class="selected-user">
                <div class="pt-1">
                  <md-button
                    class="md-icon-button back-button"
                    @click="backButton"
                  >
                    <md-icon>arrow_back</md-icon>
                  </md-button>
                </div>
                <div class="pb-1 pt-1">
                  <SUserAvatar
                    :myUser="userSelectedByTab"
                    size="small"
                    :isProfileAvatar="false"
                  />
                  <span class="sender-name title ml-2">{{
                    userSelectedByTab.username
                  }}</span>
                </div>
              </div>
              <SButtonMaterial
                color="transparent"
                buttonType="button"
                :textColor="
                  selectedSubTab === 'all' ? 'tertiary' : 'darker-grey'
                "
                @button="setSubTab('all')"
                text="Show all"
                class="sub-tab-button"
                :class="{ selected: selectedSubTab === 'all' }"
                ref="allSubTabFromUsersTab"
              />
              <SButtonMaterial
                color="transparent"
                buttonType="button"
                :iconColor="
                  selectedTab === 'items' ? 'tertiary' : 'darker-grey'
                "
                @button="setSubTab('items')"
                iconWithoutText="storefront"
                class="sub-tab-button"
                :class="{ selected: selectedSubTab === 'items' }"
                ref="itemsSubTabFromUsersTab"
              />
              <SButtonMaterial
                color="transparent"
                buttonType="button"
                :iconColor="
                  selectedTab === 'items' ? 'tertiary' : 'darker-grey'
                "
                @button="setSubTab('groups')"
                iconWithoutText="groups"
                class="sub-tab-button"
                :class="{ selected: selectedSubTab === 'groups' }"
                ref="groupsSubTabFromUsersTab"
              />
            </div>
            <div class="sub-tab" v-if="selectedTab === 'items'">
              <SButtonMaterial
                color="transparent"
                buttonType="button"
                :textColor="
                  selectedSubTab === 'all' ? 'tertiary' : 'darker-grey'
                "
                @button="setSubTab('all')"
                text="Show all"
                class="sub-tab-button"
                :class="{ selected: selectedSubTab === 'all' }"
                ref="allItemsSubTab"
              />
              <SButtonMaterial
                color="transparent"
                buttonType="button"
                :textColor="
                  selectedSubTab === 'mine-items'
                    ? 'tertiary'
                    : 'darker-grey'
                "
                @button="setSubTab('mine-items')"
                text="Mine"
                class="sub-tab-button"
                :class="{ selected: selectedSubTab === 'mine-items' }"
                ref="mineItemsSubTab"
              />
              <SButtonMaterial
                color="transparent"
                buttonType="button"
                :textColor="
                  selectedSubTab === 'others-items'
                    ? 'tertiary'
                    : 'darker-grey'
                "
                @button="setSubTab('others-items')"
                text="Others"
                class="sub-tab-button"
                :class="{ selected: selectedSubTab === 'others-items' }"
                ref="othersItemsSubTab"
              />
            </div>
            <div v-if="selectedTab === 'users' && !userSelectedByTab">
              <SChatItemListUsers
                v-for="conversation in conversationByUser"
                :key="`${conversation.type}-${conversation.user.id}`"
                :conversation="conversation"
                @button="getUser"
                :data-cy="`select-chat-with-${conversation.type}-${conversation.user.id}`"
                :ref="`${conversation.type}-${conversation.user.id}`"
              />
            </div>
            <div v-if="selectedTab === 'users' && userSelectedByTab">
              <SChatItemListUserSelected
                v-for="conversation in filteredByTabConversations"
                :key="`${conversation.keyType}-${conversation.id}`"
                :conversation="conversation"
                @button="getChat"
                @popupWindowClose="closePopupWindow"
                @popupWindowOpen="openPopupWindow"
                :data-cy="`select-chat-with-${conversation.keyType}-${conversation.id}`"
                :ref="`${conversation.keyType}-${conversation.id}`"
              />
            </div>
            <md-content class="scroll md-scrollbar" v-if="selectedTab !== 'users'">
              <SChatItemList
                v-for="conversation in filteredByTabConversations"
                :key="`${conversation.type}-${conversation.key.id}`"
                :conversation="conversation"
                @button="getChat"
                @chat-thread="closePopupWindow"
                @popupWindowOpen="openPopupWindow"
                :selected="(selectedConversation.key.id === conversation.key.id) && (selectedConversation.type === conversation.type)"
                :newMsg="getNewestMsgFromSender(conversation.messages)"
                :data-cy="`select-chat-with-${conversation.type}-${conversation.key.id}`"
                :ref="`${conversation.type}-${conversation.key.id}`"
              />
            </md-content>
          </div>

          <div class="chat-display ml-0 remove-padding chat-thread" id="chat-thread">
            <SChatThread
              :chatMsgs="selectedConversation"
              :keyId="chatKeyId"
              :hasPartner="othersItem || othersGroup  || othersGarage || isUserSelected"
              :userFromTab="userSelectedByTab"
              ref="chatThread"
            />
          </div>
        </div>
      </md-content>
      <SEmptyChatMessage v-else />
    </md-content>
    <Footer/>
  </div>
</template>

<script>
import SChatThread from "@/components/organisms/SChatThread";
import SChatItemList from "@/components/molecules/SChatItemList";
import SChatItemListUsers from "@/components/molecules/SChatItemListUsers";
import SChatItemListUserSelected from "@/components/molecules/SChatItemListUserSelected";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import SEmptyChatMessage from "@/components/organisms/SEmptyChatMessage";
import SPreloader from "@/components/organisms/SPreloader.vue";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import store from "@/vuex/store";
import Footer from "@/templates/Footer";

export default {
  name: "SMessageCenter",
  components: {
    SChatThread,
    SChatItemList,
    SChatItemListUsers,
    SChatItemListUserSelected,
    SEmptyChatMessage,
    SButtonMaterial,
    SPreloader,
    SSubHeader,
    SUserAvatar,
    Footer,
  },
  mixins: [ChatHelperVue],
  data() {
    return {
      chat: null,
      chatInputs: {},
      selectedTab: "all",
      selectedSubTab: "all",
      userSelectedByTab: null,
    };
  },
  computed: {
    conversationSortedByDate() {
      if (!this.userMessages) return [];
      const messages = [...this.userMessages] || [];
      const conversations = [...messages].sort((a, b) => {
        const dateA =
          new Date(this.getLastMsgTimeStamp(a.messages)) || new Date();
        const dateB =
          new Date(this.getLastMsgTimeStamp(b.messages)) || new Date();
        return dateB - dateA;
      });
      localStorage.setItem("conversations", JSON.stringify(this.conversationByUser));
      return conversations;
    },
    conversationByUser() {
      if (!this.userTabMessages) return [];
      const messagesByuser = [...this.userTabMessages];
      return messagesByuser;
    },
    filteredByTabConversations() {
      let conversations = this.conversationSortedByDate;
      if (this.selectedTab === "items") {
        conversations = conversations.filter((chat) => {
          return (
            chat.type === "MY_ITEM_MESSAGE" ||
            chat.type === "USERS_ITEM_MESSAGE"
          );
        });
        if (this.selectedSubTab === "mine-items") {
          conversations = conversations.filter((chat) => {
            return chat.type === "MY_ITEM_MESSAGE";
          });
        }
        if (this.selectedSubTab === "others-items") {
          conversations = conversations.filter((chat) => {
            return chat.type === "USERS_ITEM_MESSAGE";
          });
        }
      }
      if (this.selectedTab === "groups") {
        conversations = conversations.filter((chat) => {
          return (
            chat.type === "MY_MODERATOR_GROUP_MESSAGE" ||
            chat.type === "MY_GROUP_MESSAGE"
          );
        });
      }
      if (this.selectedTab === "users" && this.userSelectedByTab) {
        let userChats = this.conversationByUser.find((chat) => {
          return chat.user.id === this.userSelectedByTab.id;
        });
        userChats.groups.forEach((chat) => {
          chat.keyType = "GROUP";
        });
        userChats.items.forEach((chat) => {
          chat.keyType = "ITEM";
        });
        if (this.selectedSubTab === "items") {
          conversations = [...userChats.items];
        } else if (this.selectedSubTab === "groups") {
          conversations = [...userChats.groups];
        } else {
          conversations = [...userChats.groups, ...userChats.items];
        }
      }
      return conversations;

    },
    isUserTab() {
      return this.selectedTab === "users";
    },
    selectedConversation() {
      this.$router.replace({ path: "/s-app/message-center", query: { msgId: this.chatKeyId }})

      let selected = {};
      selected = this.conversationSortedByDate.find((chat) => {
        return chat.key.id === this.chatKeyId
      });
      return selected;
    },
    chatKeyId() {
      if (!this.chat) {
        const { msgId } = this.$route.query

        const msgIdExists = (conversation) => conversation.key.id === Number(msgId)

        if (this.conversationSortedByDate.some(msgIdExists)) return Number(msgId)

        return this.conversationSortedByDate[0].key.id
      }
      return this.chat;
    },
    othersItem() {
      if (this.selectedConversation) {
        return this.selectedConversation.type === "USERS_ITEM_MESSAGE";
      }
      return false;
    },
    othersGroup() {
      if (this.selectedConversation) {
        return this.selectedConversation.type === "MY_GROUP_MESSAGE";
      }
      return false;
    },
    othersGarage() {
      if (this.selectedConversation) {
        if(this.selectedConversation.type === "MY_GARAGE_MESSAGE"){
          return true;
        }else if(this.selectedConversation.type === "USERS_GARAGE_MESSAGE"){
          return true
        }
        return false ;
      }
      return false;
    },
    isUserSelected() {
      return this.userSelectedByTab ? true : false;
    },
    displayNewItemMessageNotice() {
      const hasUnseenMessages = this.conversationSortedByDate.find((chat) => {
        return (
          this.getNewestMsgFromSender(chat.messages) &&
          chat.messages[chat.messages.length - 1].seen === 0 &&
          (chat.type === "MY_ITEM_MESSAGE" ||
            chat.type === "USERS_ITEM_MESSAGE" ||
            chat.type === "USERS_GARAGE_MESSAGE" ||
            chat.type ===  "MY_ITEM_MESSAGE"
            )
        );
      });
      return hasUnseenMessages;
    },
    displayNewGroupMessageNotice() {
      const hasUnseenMessages = this.conversationSortedByDate.find((chat) => {
        return (
          this.getNewestMsgFromSender(chat.messages) &&
          chat.messages[chat.messages.length - 1].seen === 0 &&
          (chat.type === "MY_GROUP_MESSAGE" ||
            chat.type === "MY_MODERATOR_GROUP_MESSAGE")
        );
      });
      return hasUnseenMessages;
    }
  },
  methods: {
    closePopupWindow() {
      this.$parent.$refs.rightStickyBar.$refs.popupWindow.close();
    },
    openPopupWindow() {
      this.$parent.$refs.rightStickyBar.openClosePopup();
    },
    saveChatInput(userChatItem, newValue) {
      this.chatInputs[userChatItem] = newValue;
    },
    async getChat(chatId, lastMsgId, chatType) {
      this.chat = chatId;
      if (chatType == "item") {
        await this.setReadItemMessages({ msgsIds: [lastMsgId] });
      } else if(chatType == "garage"){
        await this.setReadGarageMessages({ msgsIds: [lastMsgId] });
      } else if (chatType == "group") {
        await this.setReadGroupMessages({ msgsIds: [lastMsgId] });
      }
      await this.fetchUserMessages();
      if (this.chatInputs[chatId]) {
        const text = this.chatInputs[chatId];
        this.$refs.chatThread.recoveryText(text);
        this.$refs.chatThread.scrollToBottom();
      } else {
        this.$refs.chatThread.cleanInputField();
      }
      this.setRequestSeen(this.$refs.chatThread.chatMsgs);
    },
    getUser(user) {
      this.userSelectedByTab = user;
    },
    setTab(tab) {
      this.selectedTab = tab;
      if (tab !== "users") {
        this.userSelectedByTab = null;
      }
    },
    setSubTab(tab) {
      this.selectedSubTab = tab;
    },
    backButton() {
      this.userSelectedByTab = null;
    },
    setRequestSeen(chatMsgs){
      const unreadNotifications = this.$parent.$refs.sLoggedHeader.$refs.sHeaderNotifications.$refs.requestsDropdown.notifications;
      const result = unreadNotifications.find((notif) => notif.itemId === chatMsgs.key.id);

      if(result){
        this.$parent.$refs.sLoggedHeader.$refs.sHeaderNotifications.$refs.requestsDropdown.setSeen(result);
      }
    },

  },
  created() {
    this.clearPopupChat();
    this.fetchUserMessages();
    this.fetchUserTabMessages();
  },
  mounted() {
    setTimeout(() => {
      if (this.$route.query.chat) {
        const keyId = parseInt(this.$route.query.chat);
        const lastMsgId = parseInt(this.$route.query.id);
        const type = this.$route.query.type;
        this.getChat(keyId, lastMsgId, type);
      }
    }, 1000);
  },
  async beforeRouteEnter(_to, _from, next) {
    try {
      await store.dispatch("fetchUserMessages");
      next();
    } catch (error) {
      console.log(error);
    }
  },
  watch:{
    '$route.query': {
      immediate: true,
      handler(newVal) {
        const keyId = parseInt(newVal.chat);
        const lastMsgId = parseInt(newVal.id);
        const type = newVal.type;
        this.getChat(keyId, lastMsgId, type);
      }
    }
  },
};
</script>

<style scoped>

::-webkit-scrollbar-thumb {
  background: #757575;
}
::-webkit-scrollbar-track {
  background: #e1e1e1;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar:horizontal{
  display: none;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track-piece {
  width: 8px;
}
.scroll {
  display: block;
  width: 100%;
  overflow: scroll;
  height: 100%;
}
.md-button {
  min-width: 64px;
  height: unset;
}
.container {
    margin: -45px auto auto auto !important;
    padding: 0 60px !important;
    max-width: 1500px;
  }
  .messages-content {
    margin: 0 !important
  }
@media only screen and (min-width: 1024px) {
  .remove-padding-left {
    padding-left: 0 !important;
  }
  .remove-padding-right {
    padding-right: 0 !important;
  }
}
@media only screen and (max-width: 1112px) {
  #chat-thread {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.page-content {
  max-height: 100%;
  height: 80vh;
}
.page-content,
.row-content,
.row-sub-content {
  background-color: transparent !important;
}

.row-content.justify-content-center {
  height: 100%;
}

.row-sub-content {
  height: 100%;
}
.icon-status {
  margin-left: unset;
}
.tab-button {
  margin: 6px 8px;
  min-width: unset;
}
.header {
  height: 120px;
}
.remove-padding {
  padding: unset;
}
.ui-block-title {
  height: 12%;
  padding: 0 10px;
  border-bottom: unset;
}
.sub-tab {
  border-bottom: 2px solid $grey-light !important;
}
.back-button i {
  color: $tertiary !important;
}
.selected-user {
  padding-top: 0.25rem;
  display: flex;
}
.selected {
  border-bottom: 2px solid $tertiary;
}

.sub-tab-button {
  width: 30%;
  text-transform: unset;
  border-radius: 0%;
  margin-bottom: 0;
}
.chat-box {
  overflow: hidden;
  height: 82%;
  margin: 0px 20px 20px 20px;
  border-radius: 5px;
  border: 2px solid $grey-light !important;
}
.chat-list {
  max-height: 100%;
  border-right: 2px solid $grey-light;
}
.chat-thread {
  height: 100%;
}
.chat-thread div {
  height: 100%;
  max-height: 100%;
}
.messages-content {
  // max-height: 500px;
  width: 100%;
  height: 100%;
  margin-top: -1.5rem;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  border-radius: 5px;
  margin-left: -0.93rem;
}
.chat-display {
  max-width: 70%;
  width: 70%;
}

@media screen and (max-width: 1112px) {
  .ui-block-title {
  justify-content: space-between;
}
  .container {
    margin: 0 !important;
    padding: 0 !important;
    max-width: 100%;
  }
  .messages-content {
    margin: 0
  }
}

@media screen and (min-width: 1112px) {
  .chat-list {
    flex: 0 0 30%;
    max-width: 30%
  }

}
</style>
